import request from '@/utils/request'

// 车辆设备码列表
export const listBicycleDeviceCodes = (pageData, formData) => {
    return request.get(`/bicycle-device-codes/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 车辆设备码-批量导出二维码图片
export const exportQrcodeBicycleDeviceCodes = (formData) => {
    return request.get(`/bicycle-device-codes/qrcode/export`, {params: formData, responseType: "blob"})
}

// 车辆设备码-导出单个二维码图片
export const getQrcodeBicycleDeviceCodes = (formData) => {
    return request.get(`/bicycle-device-codes/qrcode`, {params: formData, responseType: "blob"})
}

// 车辆设备码详情
export const detailBicycleDeviceCodes = (bicycleDeviceCodeId) => {
    return request.get(`/bicycle-device-codes/${bicycleDeviceCodeId}`)
}

// 车辆设备码-批量生成
export const generateBicycleDeviceCodes = (formData) => {
    return request.post(`/bicycle-device-codes/generate`, formData);
};

// 车辆设备码-按顺序批量绑定
// export const batchBindBicycleDeviceCodes = (formData) => {
//     return request.post(`/bicycle-device-codes/batch-bind`, formData)
// }

// 车辆设备码列表导出
export const exportBicycleDeviceCodes = (formData) => {
    return request.get(`/bicycle-device-codes/export`, {params: formData, responseType: "blob"})
}

// 车辆设备码-批量绑定
export const batchBindBicycleDeviceCodes = (formData) => {
    return request.post(`/bicycle-device-codes/batch-bind/batch`, formData)
}

// 车辆设备码-单个绑定
export const bindBicycleDeviceCodes = (formData) => {
    return request.post(`/bicycle-device-codes/bind`, formData)
}

// 车辆设备码-解绑
export const removeBicycleDeviceCodes = (bicycleDeviceCodeId) => {
    return request.delete(`/bicycle-device-codes/${bicycleDeviceCodeId}`)
}
